import React from "react";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import SEO from "../components/SEO";
import SocialLinks from "../components/landing/SocialLinks";
import { Mail } from "lucide-react";
import { SITE } from "../config/site";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact — Culmora OS"
        description="Contact Culmora OS for product, partnership or general enquiries."
        path="/contact"
      />
      <Header />
      <main id="main" className="pt-10 pb-20">
        <div className="z-page">
          <div className="max-w-[720px] mx-auto">
            <h1 className="font-display text-[clamp(36px,5vw,56px)] leading-[1.05]">
              Contact Culmora OS
            </h1>
            <p className="mt-4 text-[16px] md:text-[17px] leading-[1.6] text-[hsl(var(--z-text-muted))]">
              For product, partnership or general enquiries, contact Culmora OS.
            </p>
            <div className="mt-10 z-frame p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <span className="w-12 h-12 rounded-2xl border border-[hsl(var(--z-teal))]/30 text-[hsl(var(--z-teal))] flex items-center justify-center" style={{ background: "hsl(var(--z-teal-soft))" }} aria-hidden="true">
                <Mail size={20} />
              </span>
              <div className="min-w-0">
                <p className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--z-text-soft))]">
                  Email
                </p>
                <a
                  href={`mailto:${SITE.contactEmail}`}
                  className="font-display text-[22px] md:text-[26px] text-[hsl(var(--z-text))] hover:text-[hsl(var(--z-teal))] transition-colors break-all"
                  data-testid="contact-email-link"
                >
                  {SITE.contactEmail}
                </a>
              </div>
            </div>
            <p className="mt-6 text-[14.5px] text-[hsl(var(--z-text-muted))]">
              For product access requests, use the request form on the home page.
            </p>
            <div className="mt-10">
              <SocialLinks testId="contact-social" />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
